import { useCallback } from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';

export type ConfirmDialogProps = {
  open: boolean;
  title: string;
  cancelButtonTitle?: string;
  okButtonTitle?: string;
  onClose: (options: { accepted: boolean }) => void;
};

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, cancelButtonTitle, okButtonTitle, onClose }) => {
  const handleCancel = useCallback(() => {
    onClose({ accepted: false });
  }, [onClose]);

  const handleAccept = useCallback(() => {
    onClose({ accepted: true });
  }, [onClose]);

  return (
    <Dialog open={open} fullWidth maxWidth='xs' onClose={handleCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogActions>
        <Button color='inherit' onClick={handleCancel}>
          {cancelButtonTitle ? cancelButtonTitle : 'CANCEL'}
        </Button>
        <Button variant='contained' color='error' onClick={handleAccept}>
          {okButtonTitle ? okButtonTitle : 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
